<div class="mb-3">
  <div>All fields optional</div>
  <mat-form-field class="me-3">
    <input
      matInput
      [matDatepicker]="startPicker"
      placeholder="Start Date"
      [(ngModel)]="startDate"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="startPicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #startPicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="me-3">
    <input
      matInput
      [matDatepicker]="endPicker"
      placeholder="End Date"
      [(ngModel)]="endDate"
    />
    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
    <mat-datepicker #endPicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="me-3">
    <mat-label>Type</mat-label>
    <input matInput type="text" [(ngModel)]="type" />
    @if (type) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="type = ''">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
  <mat-form-field class="me-3">
    <mat-label>Limit</mat-label>
    <input matInput type="text" [(ngModel)]="limit" />
    <mat-hint>Default: 500</mat-hint>
    @if (limit) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="limit = ''">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <button
    mat-raised-button
    color="primary"
    class="mx-auto me-3"
    (click)="getAudits()"
  >
    Get Report
  </button>

  @if (!loading && auditData) {
    <div class="my-3">
      <button
        mat-raised-button
        color="primary"
        class="mx-auto me-3"
        (click)="retryAudits()"
        [disabled]="selectedIds.length === 0"
      >
        Retry Selected
      </button>
      <button
        mat-raised-button
        color="primary"
        class="mx-auto me-3"
        (click)="deleteAudits()"
        [disabled]="selectedIds.length === 0"
      >
        Delete Selected
      </button>
    </div>

    <kendo-grid
      [kendoGridBinding]="auditData"
      [pageSize]="25"
      [pageable]="true"
      [selectable]="{ mode: 'multiple', checkboxOnly: true }"
      kendoGridSelectBy="id"
      [(selectedKeys)]="selectedIds"
      [navigable]="true"
    >
      <kendo-grid-checkbox-column [width]="40"></kendo-grid-checkbox-column>
      @for (col of gridColumns; track $index) {
        <kendo-grid-column [field]="col"></kendo-grid-column>
      }
    </kendo-grid>
  }
  <ngx-loading [show]="loading"></ngx-loading>
</div>
